import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeExchangeDateCommand extends BaseCommand {
  CommandName = "ChangeExchangeDate";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
